import DefaultProfilePicture from "assets/imgs/no-profile-picture.svg";

export const DefaultPicture = DefaultProfilePicture;
